import { render } from "./FolderTree.vue?vue&type=template&id=533098da&scoped=true"
import script from "./FolderTree.vue?vue&type=script&lang=js"
export * from "./FolderTree.vue?vue&type=script&lang=js"

import "./FolderTree.vue?vue&type=style&index=0&id=533098da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533098da"],['__file',"src/containerss/FolderTree.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "533098da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('533098da', __exports__)) {
    api.reload('533098da', __exports__)
  }
  
  module.hot.accept("./FolderTree.vue?vue&type=template&id=533098da&scoped=true", () => {
    api.rerender('533098da', render)
  })

}


export default __exports__